function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.56 3.234a4.212 4.212 0 015.956 5.957l-8.462 8.462a2.481 2.481 0 01-3.509-3.509l6.44-6.44a.75.75 0 111.06 1.06l-6.439 6.44a.981.981 0 101.388 1.388l8.462-8.462a2.712 2.712 0 10-3.836-3.836l-8.569 8.569a4.443 4.443 0 106.284 6.284l6.546-6.546a.75.75 0 111.061 1.06l-6.546 6.546a5.943 5.943 0 01-8.405-8.405l8.568-8.568z",
  fill: "#5C6A79"
});

var SvgAttach = function SvgAttach(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default SvgAttach;